const GET = {
  loginGoogle: '/auth/google_oauth2/callback',
  languageLevelOptions: '/dictionaries/language_levels',
  occupationOptions: '/dictionaries/occupations',
  cityOptions: '/dictionaries/cities',
  cities: '/cities',
  taxClasses: '/tax_classes',
  certificates: '/certificates',
  countryOptions: '/dictionaries/countries',
  checkEmail: '/user_accounts/email_available',
  getUserAccount: (uuid: string) => `/candidates/${uuid}/user_accounts`,
  getCandidate: (uuid?: string) => `/candidates/${uuid}`,
  getCandidateDetailsJobShifts: (uuid?: string, params?: string) =>
    `/candidates/${uuid}/candidate_job_shifts${params}`,
  getAllUserAccounts: '/candidates/user_accounts',
  getUserAccounts: (candidateStatus: UCM.CandidateStatusType) =>
    `/candidates/user_accounts/${candidateStatus}`,
  interviewMethodOptions: '/dictionaries/prescreening_methods',
  getPrescreening: (candidateUuid: string, uuid: string) =>
    `/candidates/${candidateUuid}/prescreenings/${uuid}`,
  getAllProjects: '/projects',
  getProject: (uuid: string) => `/projects/${uuid}`,
  getProjectSettings: (uuid: string) => `/projects/${uuid}/settings`,
  getProjectStaffPlan: (projectUuid: string) =>
    `/projects/${projectUuid}/staff_plan`,
  getProjectJobsBulkExport: (projectUuid: string, params?: string) =>
    `/projects/${projectUuid}/jobs/bulk_export_csv${params ?? ''}`,
  getImportProjectJobsProgress: (projectUuid: string) =>
    `/projects/${projectUuid}/jobs/bulk_import_progress`,
  getImportProjectJobsResult: (projectUuid: string) =>
    `/projects/${projectUuid}/jobs/bulk_import_result`,
  getImportProjectJobsResultFile: (projectUuid: string) =>
    `/projects/${projectUuid}/jobs/bulk_import_result_file`,
  getJobs: (projectUuid: string) => `projects/${projectUuid}/jobs`,
  getJobStaffPlan: (jobUuid: string) => `/jobs/${jobUuid}/staff_plan`,
  getLanguageScores: '/language_scores',
  getCandidates: '/candidates',
  getCandidatesFilters: '/candidates/filters',
  projectFilters: '/projects/filters',
  projectStatusOptions: '/project_statuses',
  projectManagerOptions: '/project_managers',
  getLanguageOptions: '/languages',
  getJobTypeOptions: '/job_types',
  getTaskOptions: '/tasks',
  getDynamicFields: '/dynamic_fields',
  getStaffTypeOptions: '/staff_types',
  getStaffType: (staffTypeUuid: string) => `/staff_types/${staffTypeUuid}`,
  getJob: (jobUuid?: string, params?: string) =>
    `jobs/${jobUuid}/details${params ?? ''}`,
  getPositionJobDates: (projectUuid: string) =>
    `/position_job_dates/${projectUuid}`,
  getDownloadPositionJobDates: (params: string) =>
    `/position_job_dates/export_csv?${params}`,
  getDailyBriefing: (params: string) => `/position_job_dates?${params}`,
  getBriefingDetails: (jobUuid: string) => `/jobs/${jobUuid}/briefings`,
  getDailyBriefingDetails: (jobUuid: string, uuid: string) =>
    `/jobs/${jobUuid}/briefings/${uuid}`,
  getJobApplications: (jobUuid: string, type: string, params: string) =>
    `/jobs/${jobUuid}/job_applications/${type}${params}`,
  getBookedToTransfer: (standbyUuid: string, params: string) =>
    `/jobs/${standbyUuid}/job_applications/booked_to_transfer?${params}`,
  getBookedFromTransfer: (jobUuid: string, params: string) =>
    `/jobs/${jobUuid}/job_applications/booked_from_transfer?${params}`,
  getRatingScores: `/user_rating_scores`,
  getUserRatingScores: (jobUuid: string) =>
    `/jobs/${jobUuid}/job_applications/user_job_performance_ratings`,
  getAcceptReason: (params: string) => `/acceptance_reasons?${params}`,
  getRejectReason: (params: string) => `/rejection_reasons?${params}`,
  getFieldsCategory: (params: string) => `/field_categories?${params}`,
  getInternalAttributes: (userUuid?: string, params?: string) =>
    `/candidates/${userUuid}/dynamic_fields?${params}`,
  getCalendarJobs: (jobUuid: string, params: string) =>
    `/jobs/${jobUuid}/job_applications/flex_date?${params}`,
  getCancellationShifts: (params: string) =>
    `/cancellation_notices/shift_options?${params}`,
  getCancellationNotices: (uuid?: string) => `/cancellation_notices/${uuid}`,
  getJobCoverages: (jobUuid: string) => `standby_jobs/${jobUuid}/job_coverages`,
  getShiftsList: (uuid: string) => `/jobs/${uuid}/shifts`,
  backupShiftOptions: (jobUuid: string, params: string) =>
    `jobs/${jobUuid}/backup_shift_options?${params}`,
  verificationMethods: `/projects/verification_methods`,
  getAssetsPictures: (params: string) => `/assets/pictures?${params}`,
  getAcceptedCount: (jobUuid: string) =>
    `/jobs/${jobUuid}/job_applications/accepted_count`,
  getJobStatuses: (params?: string) => `job_statuses?${params}`,
  getProjectTypes: '/project_types',
  getContractFilters: '/user_contracts/filters',
  getContracts: `/user_contracts`,
  getDownloadContract: (id: string) => `user_contracts/${id}`,
  contractEmploymentTypeOptions: `/user_contracts/employment_types`,
  contractRequirementOptions: `/user_contracts/requirements`,
  documentTemplateOptions: `/user_contracts/document_templates`,
  customerOptions: `/customers`,
  contractTaskOptions: `/user_contracts/task_types`,
  contractJobTypeOptions: `/user_contracts/job_types`,
  contractTariffGroupOptions: `/user_contracts/tariff_groups`,
  contractLocationOptions: `/user_contracts/locations`,
  contractCertificateOptions: `/certificates/proof_required`,
  cancellationFilters: '/cancellation_notices/filters',
  cancellationKindOptions: '/cancellation_notices/kind_options',
  cancellationReasonOptions: '/cancellation_notices/reason_options',
  cancellationStatusOptions: '/cancellation_notices/statuses',
  cancellationConfirmationStatusOptions:
    '/cancellation_notices/confirmation_statuses',
  getCancellations: (params: string) => `/cancellation_notices${params}`,
  getFines: (params: string) => `/fines${params}`,
  getPreviousFineReports: (params: string) => `/fines_reports${params}`,
  downloadFineReport: (uuid: string) => `/fines_reports/${uuid}/download`,
  tutorials: `/tutorial`,
  fieldCategories: `/field_categories`,
  tutorialTypeOptions: `/tutorials/types`,
  cohortOptions: `/tutorials/cohorts`,
  tutorial: (uuid: string) => `/tutorial/${uuid}`,
  tutorialQuestions: (uuid: string) => `/tutorial/${uuid}/questions`,
  fieldCategory: (uuid: string) => `/field_categories/${uuid}`,
  dynamicFields: (fieldCategoryUuid: string) =>
    `/field_categories/${fieldCategoryUuid}/dynamic_fields`,
  dynamicFieldTypes: `/field_types`,
  getPayrollProgress: '/payrolls/progress',
  getPayrolls: (params: string) => `/payrolls${params}`,
  downloadPayroll: (uuid: string) => `/payrolls/${uuid}`,
  getTargetShiftOptions: (jobUuid: string, jobId: string) =>
    `/standby_jobs/${jobUuid}/covered_jobs/${jobId}/target_shift_options`,
  downloadCandidates: (params?: string) => `/candidates/export_csv${params}`,
  getCandidateShifts: (params: string) => `/candidate_job_shifts${params}`,
  getCandidateJobShifts: '/candidate_job_shifts',
  deviationReasonOptions: '/candidate_job_shifts/deviation_reason_options',
  getVerificationFiles: (type: string, params?: string) => `/${type}${params}`,
  getVerificationRejectReason: (params?: string) =>
    `/asset_rejection_reasons?${params}`,
  getCancellationProof: (uuid: string) => `/cancellation_proofs/${uuid}`,
  downloadVerificationAsset: (type: string, uuid: string) =>
    `/assets/${type}/${uuid}/download`,
  downloadCancellationProof: (uuid: string) =>
    `/cancellation_proofs/${uuid}/download`,
  userUnavailabilities: `/user_unavailabilities`,
  downloadVerificationCode: (projectUuid: string) =>
    `/projects/${projectUuid}/download_verification_code`,
  userStatuses: '/user_statuses',
  autoAcceptanceResults: '/auto_acceptance_results',
  autoAcceptance: '/auto_acceptance',
};

const POST = {
  loginUser: '/login/admin',
  createPreRegistration: '/candidates/user_accounts',
  createPrescreening: (candidateUuid: string) =>
    `/candidates/${candidateUuid}/prescreenings/`,
  createApplyUser: '/quick_apply',
  createJob: (projectUuid: string) => `/projects/${projectUuid}/jobs`,
  createStaffType: '/staff_types',
  createJobFields: (jobUuid: string) => `jobs/${jobUuid}/dynamic_fields`,
  createBriefing: (jobUuid: string) => `jobs/${jobUuid}/briefings`,
  createUserRating: (jobUuid: string, applicationUuid: string) =>
    `/jobs/${jobUuid}/job_applications/${applicationUuid}/user_job_performance_ratings`,
  cancellationNotices: 'cancellation_notices',
  createShift: (uuid: string) => `/jobs/${uuid}/shifts`,
  createBackupJob: (jobUuid: string) => `/jobs/${jobUuid}/backup_jobs`,
  finesReports: `/fines_reports`,
  createFines: `/fines`,
  createTutorial: `/tutorial`,
  createFieldCategory: `/field_categories`,
  tutorialQuestion: `tutorial/questions`,
  questionOption: (questionUuid: string) =>
    `tutorial/questions/${questionUuid}/options`,
  dynamicField: `/dynamic_fields`,
  dynamicFieldOptions: (dynamicFieldUuid: string) =>
    `/dynamic_fields/${dynamicFieldUuid}/options`,
  createPayroll: '/payrolls',
  createContract: '/user_contracts',
  standbyTransfer: (jobUuid: string) =>
    `standby_jobs/covered_jobs/${jobUuid}/transfer`,
  createCandidateCertificate: (uuid: string) =>
    `/candidates/${uuid}/certificates`,
  createSignByUcm: (contractUuid: string) =>
    `/user_contracts/${contractUuid}/sign_by_ucm`,
  archiveContract: `user_contracts/archive`,
  approveTimeTracking: (timeTrackingUuid: string) =>
    `/candidate_job_shifts/${timeTrackingUuid}/approve`,
  saveTimeTracking: (timeTrackingUuid: string) =>
    `/candidate_job_shifts/${timeTrackingUuid}/submit`,
  importTimeTracking: `/candidate_job_shifts/import_client_csv`,
  createCandidateDynamicField: (uuid: string) =>
    `/candidates/${uuid}/dynamic_fields`,
  zupAccess: (candidateUuid: string) =>
    `/candidates/${candidateUuid}/zup_access`,
  getActiveProjects: '/getActiveProjects',
  exportActiveProjects: '/export_csv/getActiveProjects',
  acceptShifts: '/bookShifts',
};

const PATCH = {};

const PUT = {
  updateUserAccount: (uuid: string) => `/candidates/${uuid}/user_accounts`,
  updatePrescreening: (candidateUuid: string, uuid: string) =>
    `/candidates/${candidateUuid}/prescreenings/${uuid}`,
  grantStudentAccess: (candidateUuid: string) =>
    `/candidates/${candidateUuid}/user_roles/grant_student_access`,
  markAccountDeleted: (candidateUuid: string) =>
    `/candidates/${candidateUuid}/account_deletion/mark_as_deleted`,
  setProjectPriority: (projectUuid: string) =>
    `/projects/${projectUuid}/set_priority`,
  removeProjectPriority: (projectUuid: string) =>
    `/projects/${projectUuid}/remove_priority`,
  updateStaffType: (staffUuid: string) => `/staff_types/${staffUuid}`,
  updateJob: (jobUuid: string) => `jobs/${jobUuid}`,
  importProjectJobs: (projectUuid: string) =>
    `/projects/${projectUuid}/jobs/bulk_import_csv`,
  importPositionJobDates: (params: string) =>
    `/position_job_dates/import_csv?${params}`,
  briefingAssignUsers: (params: string) =>
    `/position_job_dates/assign_users?${params}`,
  updateBriefingDetails: (jobUuid: string, uuid: string) =>
    `/jobs/${jobUuid}/briefings/${uuid}`,
  updateJobVisibility: (jobUuid: string, visible: boolean) =>
    `/jobs/${jobUuid}/${visible ? 'publish' : 'hide'}`,
  updateJobStatus: (jobUuid: string, status: string) =>
    `/jobs/${jobUuid}/${status}`,
  updateJobFavorite: (
    jobUuid: string,
    applicationUuid: string,
    favorite: boolean,
  ) =>
    `jobs/${jobUuid}/job_applications/${applicationUuid}/${favorite ? 'favorite' : 'unfavorite'}`,
  updateUserRating: (
    jobUuid: string,
    applicationUuid: string,
    ratingUuid: string,
  ) =>
    `/jobs/${jobUuid}/job_applications/${applicationUuid}/user_job_performance_ratings/${ratingUuid}`,
  acceptAllShifts: (jobUuid: string, userUuid: string) =>
    `/candidates/${userUuid}/jobs/${jobUuid}/job_applications/accept`,
  rejectAllShifts: (jobUuid: string, userUuid: string) =>
    `/candidates/${userUuid}/jobs/${jobUuid}/job_applications/reject`,
  acceptShift: (jobUuid: string, applicationUuid: string) =>
    `/jobs/${jobUuid}/job_applications/${applicationUuid}/accept`,
  rejectShift: (
    jobUuid: string,
    applicationUuid: string,
    type: 'reject' | 'cancel',
  ) => `/jobs/${jobUuid}/job_applications/${applicationUuid}/${type}`,
  reapplyShift: (jobUuid: string, shiftUuid: string) =>
    `/jobs/${jobUuid}/job_applications/${shiftUuid}/reapply`,
  updateCancellationNotices: (uuid?: string) => `/cancellation_notices/${uuid}`,
  withdrawCancellationNotices: (uuid?: string) =>
    `/cancellation_notices/${uuid}/withdraw`,
  updateJobCoverages: (jobUuid: string) =>
    `standby_jobs/${jobUuid}/job_coverages`,
  updateShift: (jobUuid: string, shiftUuid: string) =>
    `/jobs/${jobUuid}/shifts/${shiftUuid}`,
  updateBackupJob: (uuid: string) => `/backup_jobs/${uuid}`,
  updateFine: (uuid: string) => `/fines/${uuid}`,
  updatePayFine: (uuid: string) => `/fines/${uuid}/pay`,
  updateApproveFines: '/fines/approve',
  updateRevertFines: '/fines/revert',
  updateExemptFines: '/fines/exempt',
  updateRebookShift: (applicationUuid: string) =>
    `/candidate_job_shifts/${applicationUuid}/reset_status`,
  updateTaxClass: (uuid: string) => `/candidates/${uuid}/tax_class`,
  updateTutorial: (tutorialUuid: string) => `/tutorial/${tutorialUuid}`,
  updateFieldCategory: (categoryUuid: string) =>
    `/field_categories/${categoryUuid}`,
  updateTutorialQuestion: (questionUuid: string) =>
    `/tutorial/questions/${questionUuid}`,
  updateQuestionOption: (questionUuid: string, optionUuid: string) =>
    `/tutorial/questions/${questionUuid}/options/${optionUuid}`,
  updateDynamicField: (dynamicFieldUuid: string) =>
    `/dynamic_fields/${dynamicFieldUuid}`,
  updateDynamicFieldOption: (dynamicFieldUuid: string, optionUuid: string) =>
    `/dynamic_fields/${dynamicFieldUuid}/options/${optionUuid}`,
  updateContract: (contractUuid: string) => `/user_contracts/${contractUuid}`,
  activateContract: (contractUuid: string) =>
    `/user_contracts/${contractUuid}/activate`,
  requestSignature: (contractUuid: string) =>
    `/user_contracts/${contractUuid}/request_signature`,
  cancelContract: (contractUuid: string) =>
    `user_contracts/${contractUuid}/cancel`,
  approveVerificationFile: (url: string) => `/${url}/approve`,
  rejectVerificationFile: (url: string) => `/${url}/reject`,
  retryVerificationFile: (type: string, fileUuid: string) =>
    `/${type}/${fileUuid}/challenge`,
  updateCancelTimeTracking: (timeTrackingUuid: string) =>
    `/candidate_job_shifts/${timeTrackingUuid}/cancel`,
  cancelUnavailabilities: (uuid: string) =>
    `/user_unavailabilities/${uuid}/cancel`,
  reinstatePhysicalContract: (contractUuid: string) =>
    `/user_contracts/${contractUuid}/reinstate_physical`,
  reinstatePhysicalShortTermContract: (jobApplicationUuid: string) =>
    `/job_applications/${jobApplicationUuid}/reinstate_physical`,
  acceptSuggestion: (resultId: number) =>
    `/auto_acceptance_results/${resultId}/accept`,
  rejectSuggestion: (resultId: number) =>
    `/auto_acceptance_results/${resultId}/reject`,
  vetoApplication: (applicationId: number) =>
    `/auto_acceptance_skipped_applications/${applicationId}/veto`,
};

const DELETE = {
  deleteStaffType: (staffUuid: string) => `/staff_types/${staffUuid}`,
  deleteJob: (jobUuid: string) => `/jobs/${jobUuid}`,
  deleteJobFields: (jobUuid: string) => `jobs/${jobUuid}/dynamic_fields`,
  deleteShift: (jobUuid: string, shiftUuid: string) =>
    `/jobs/${jobUuid}/shifts/${shiftUuid}`,
  deleteContract: (contractUuid: string) => `/user_contracts/${contractUuid}`,
  fines: '/fines',
  deletePayroll: (uuid: string) => `/payrolls/${uuid}`,
  deleteCandidateCertificate: (userUuid: string, certificateCode: string) =>
    `/candidates/${userUuid}/certificates/${certificateCode}`,
  deleteTutorial: (tutorialUuid: string) => `/tutorial/${tutorialUuid}`,
  deleteFieldCategory: (categoryUuid: string) =>
    `/field_categories/${categoryUuid}`,
  deleteTutorialQuestion: (tutorialUuid: string, questionUuid: string) =>
    `/tutorial/${tutorialUuid}/questions/${questionUuid}`,
  deleteQuestionOption: ({
    optionUuid,
    tutorialUuid,
    questionUuid,
  }: {
    optionUuid: string;
    tutorialUuid: string;
    questionUuid: string;
  }) =>
    `/tutorial/${tutorialUuid}/questions/${questionUuid}/options/${optionUuid}`,
  deleteDynamicField: (uuid: string) => `dynamic_fields/${uuid}`,
  deleteDynamicFieldOption: (dynamicFieldUuid: string, optionUuid: string) =>
    `dynamic_fields/${dynamicFieldUuid}/options/${optionUuid}`,
};

export const API = { GET, PUT, POST, PATCH, DELETE };
